import { FundingInfoStrip, type FundingInfoStripProps } from '@/components/FundingInfoStrip';
import { TradeVolumeStrip } from '@/components/TradeVolumeStrip';
import './TradingOverviewBar.css';

type Props = {
  exchange1: string;
  exchange2: string;
  exchange1InstId: string;
  exchange2InstId: string;
  showVolume: boolean;
  showFunding: boolean;
  funding: Omit<FundingInfoStripProps, 'variant' | 'exchange1' | 'exchange2'>;
};

export function TradingOverviewBar({
  exchange1,
  exchange2,
  exchange1InstId,
  exchange2InstId,
  showVolume,
  showFunding,
  funding,
}: Props) {
  return (
    <div className="realtime-spread-filter-overview-bar">
      {showVolume ? (
        <div className="realtime-spread-filter-overview-block">
          <span className="realtime-spread-filter-overview-block-label">交易量</span>
          <TradeVolumeStrip
            variant="header"
            exchange1={exchange1}
            exchange2={exchange2}
            exchange1InstId={exchange1InstId}
            exchange2InstId={exchange2InstId}
          />
        </div>
      ) : null}
      {showFunding ? (
        <div className="realtime-spread-filter-overview-block">
          <span className="realtime-spread-filter-overview-block-label">Funding</span>
          <FundingInfoStrip
            variant="header"
            exchange1={exchange1}
            exchange2={exchange2}
            {...funding}
          />
        </div>
      ) : null}
    </div>
  );
}
